<template>
  <router-link
    :to="{ path: `/plants/${this.plant.id}` }"
    style="text-decoration: none; color: inherit"
  >
    <div class="size card-plant">
      <div class="size image">
        <img
          :src="getImgPlant(plant.imgs)"
          :style="{
            width: 100 + '%',
            maxHeight: 240 + 'px',
            objectFit: 'cover',
          }"
          alt="plant image"
        />
      </div>
      <div class="summary">
        <p class="title">{{ this.plant.name }}</p>
        <p class="subtitle">{{ this.plant.botanicName }}</p>
        <span class="date">Created: {{ plant.dateCreate.split("T")[0] }}</span>
        <div>
          <span
            v-for="category in plant.categories"
            :key="category.id"
            class="badge-inline badge"
            v-bind:style="{
              'background-color': getCategoryColor(category.key),
            }"
            ><div>{{ category.label }}</div>
          </span>
          <span
            v-for="origin in plant.origins"
            :key="origin"
            class="badge-inline badge"
            ><div>{{ origin }}</div>
          </span>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import Plant from "@/models/Plant";

export default {
  name: "CardPlant",
  props: {
    plant: Plant,
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    getImgPlant: function (imgs) {
      if (imgs.length > 0) {
        return process.env.VUE_APP_URL_IMAGE + imgs[0];
      }
    },
    getCategoryColor: function (keyCategory) {
      return this.colorHexaCategoryList.find(
        (colorCategory) => colorCategory.key === keyCategory
      ).color;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-plant {
  background-color: $color-gray;
  box-shadow: rgba(153, 153, 153, 0.4) 0px 5px 5px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover * {
    color: #fff;
  }

  &:hover {
    background-color: $color-primary;
    transform: scale(1.05);
  }
}
.summary {
  display: flex;
  flex-direction: column;
  padding: 0.2rem 0.5rem 0.2rem 0.5rem;
}
.title {
  color: $color-secondary;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
  margin-top: 0;
  max-height: 50px;
  text-overflow: ellipsis;
  line-height: 16px;
  @media (min-width: $constraint-width-small) {
    font-size: large;
  }
}
.subtitle {
  @media (min-width: $constraint-width-small) {
    font-size: small;
  }
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 0.5rem;
  margin-top: 0;
}
.badge {
  color: #fff;
  background-color: $color-qrious-purple-gradient;
  border-radius: 50rem !important;
  font-size: 0.69rem;
  font-weight: 700;
  margin: 0.2rem 0.2rem 0.2rem;
  padding: 0.25em 0.65em;
  vertical-align: baseline;
}
.badge:first-child {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.badge-inline {
  display: inline-block;
}
.date {
  color: gray;
  font-size: 12px;
  font-style: italic;
  @media (min-width: $constraint-width-small) {
    font-size: small;
  }
}
</style>
